const COMMON_STYLES = {
  px: '32px',
  flex: '1 0 486px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  minHeight: '430px',
  overflow: 'auto',
  py: '40px',
  boxSizing: 'border-box',
};

const ID = 'enable-payment-methods';
const SCROLL_INDICATOR_OFFSET = 100;

const TITLE = 'Select which payment methods you have enabled through your Payment Service Provider';
const DESC =
  'These payment methods will be made available to you when creating automations and logic for your checkoutYou can always edit your selection in the Settings page';

export { COMMON_STYLES, ID, SCROLL_INDICATOR_OFFSET, TITLE, DESC };
